export default __webpack_public_path__ + "static/step6-4303065632ed3bdd03ebcf3e5c5eab3f.png";